module.exports = {
  REACT_APP_API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT,
  REACT_APP_S3_BUCKET_PRESIGN_URL: process.env.REACT_APP_S3_BUCKET_PRESIGN_URL,
  REACT_APP_IS_ENABLE_TRANS_DEBUG: !!process.env.REACT_APP_IS_ENABLE_TRANS_DEBUG,
  REACT_APP_LA_DOMAIN: process.env.REACT_APP_LA_DOMAIN,

  IS_DEV: !process.env.REACT_APP_DEPLOY_ENV || process.env.REACT_APP_DEPLOY_ENV === 'dev',
  PORT: process.env.PORT
};
